// extracted by mini-css-extract-plugin
export default {"posts":"inicio_posts__xeXPP"};